// extracted by mini-css-extract-plugin
export default {"mainContainer":"OrderStatusCard_mainContainer__zC6zb"};